import { stringify } from 'query-string';
import { BASE_URL } from 'constants/api';

import actions from './index';

export const ACTIONS = {
  GET: 'PREFERRENCE_TEACHER_SLOTS_GET',
  GET_SUCCESS: 'PREFERRENCE_TEACHER_SLOTS_GET_SUCCESS',
  GET_FAILURE: 'PREFERRENCE_TEACHER_SLOTS_GET_FAILURE',
};

export const get = actions.get(
  (studentId, query, meta) => `${BASE_URL}/classroom/teacher-slots/?${stringify(meta)}`,
  {
    PENDING: ACTIONS.GET,
    SUCCESS: ACTIONS.GET_SUCCESS,
    FAILURE: ACTIONS.GET_FAILURE,
  },
);
